
import * as React from "react";
import { useState,useEffect,useRef } from "react";
import { Box, Button, Typography,Grid2, useMediaQuery, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { QRCodeCanvas } from "qrcode.react";
import SignatureCanvas from "react-signature-canvas";
import { FileUploader } from "react-drag-drop-files";
import io from "socket.io-client";
import CryptoJS from "crypto-js";
import {CircularProgress} from "@mui/material";
import lock from "../../../../Assets/Images/lock.svg"
import success from "../../../../Assets/Images/bvsuccess.svg"
import SignUpBg from "../../../../Assets/Images/Signup_web.png";
import icon from "../../../../Assets/Images/icon.svg";
import navLogo from "../../../../Assets/Images/logo.svg"

import {
  checkAndNavigate,
  generateQR,
  retakeConfirm,
  setActiveStep,
  Signature,
  retakeSignature
} from "../../../../Redux/usersSlice";

import SignatureStyles from "../Signature.module.css";
import CloseIcon from '@mui/icons-material/Close';
import { ArrowBack } from "@mui/icons-material";


export default function CaptureRetakeSignature() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);

  const { retakeAuth } = useSelector(state => state.user);


  const signCanvasRef = useRef(null);

  const [isQRMode, setIsQRMode] = useState(false);
  const [isMobileQRFlow, setIsMobileQRFlow] = useState(false);
  const [qrURL, setQrURL] = useState("");
  const [socket, setSocket] = useState(null);
  const [errMessage,setErrMessage] = useState(true)
  const [mode,setMode] = useState("draw")
  const [isLoading,setIsLoading] = useState("")
  const [checkStatus,setCheckStatus] = useState("")

  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedBase64, setUploadedBase64] = useState(null);
  const [isCompleted , setIsCompleted] = useState(false)
 const [user, setUser] = React.useState({
        mobile: "",
        email: "",
        user_id: ""
    })
  const source = "Signature_retake";

  const screen768px = useMediaQuery("(max-width : 768px)")
  const isMobile = useMediaQuery('(max-width:1000px)');
  const isSmallScreen = useMediaQuery('(max-width:600px)');

 

  const SOCKET_SERVER_URL = window.location.hostname.includes("localhost") || window.location.hostname.includes("staging") ? "https://admin-backend-staging.tradeboss.co" : "https://admin-backend.tradeboss.co"


  // Initialize socket connection when QR is generated
  useEffect(() => {
    if (!isQRMode) return;

    const socketInstance = io(SOCKET_SERVER_URL, { transports: ["websocket"] });
    setSocket(socketInstance);

    socketInstance.on("connect", () => {
      console.log("Connected to Socket.io server with ID:", socketInstance.id);
    });

    setTimeout(() => {
      const registrationPayload = {
        email: retakeAuth?.email,
        mobile: retakeAuth?.mobile,
        socket_id: socketInstance.id,
        stage: "Signature"
      };
      console.log(registrationPayload, "data");
      socketInstance.emit('register', registrationPayload);
      localStorage.setItem("socket_id", socketInstance.id);
    }, 2500);

    socketInstance.on("signature-status", (message) => {
      window.location.assign(message);
    });

    return () => {
      socketInstance.disconnect();
      console.log('Disconnected from Socket.io server');
    };

  }, [isQRMode]);

  // Sync Redux step with current path if not in mobile flow
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "retake_signature_page_viewed",
      page_path: window.location.pathname
    });
  }, []);

  useEffect(()=>{

    if (!retakeAuth.mobile) return
    (async ()=>{
        try{
          const signatureStatus = await dispatch(retakeConfirm({ mobile: retakeAuth?.mobile, email: retakeAuth?.email, type: "signature"})).unwrap();
            if(signatureStatus?.data?.data?.success){
              setIsCompleted(true)
              // AVchanges
              if(isQRMode){
                setQrURL("")
                setIsQRMode(false)
                setErrMessage("")
              }
            }else{
              if(isQRMode){
                setErrMessage("Your signature is still pending !!")
              }
            }
        }catch(e){
            console.log(e)
        }

    })()
  }, [checkStatus,retakeAuth])

 

  const handleGenerateQR = async () => {
    setErrMessage("")
    try {
      const response = await dispatch(generateQR({ mobile: retakeAuth?.mobile, email: retakeAuth?.email, source})).unwrap();
      setQrURL(response.data.url);
      setIsQRMode(true);
      setUploadedFile(null);
      signCanvasRef.current.clear();
    } catch (error) {
      console.error('Failed to generate QR:', error);
    }
  };



  const handleSignatureSubmit = async () => {
    setErrMessage("")
    if (qrURL) {
      setQrURL("");
      setIsQRMode(false);
      return;
    }
    setIsLoading(true)
    const signData = signCanvasRef.current?.toDataURL("image/jpeg", 100);

    console.log("signData", signData)
  
    console.log(signData?.toString().length , "length")
    if(!uploadedFile){
      setMode("draw")
      if (screen768px){
        console.log("hellooo")
        if (signData.toString().length < 20000) {
          setErrMessage("Signature is too Short")
          setIsLoading(false)
          return
        }
      }else{
        console.log("hellooooooo")
        if (signData.toString().length < 10000) {
          setErrMessage("Signature is too Short")
          setIsLoading(false)
          return
        }
      }
      
    }

    

    try {
      // if (uploadedFile) {
      if (uploadedBase64){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "retake_signature_upload",
          page_path: window.location.pathname
        });
      }else{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "retake_signature_capture",
          page_path: window.location.pathname
        });
      }
      const response = await dispatch(retakeSignature({ mobile: retakeAuth?.mobile, email: retakeAuth?.email, sign_data: uploadedBase64 || signData, source: "retake" })).unwrap();
        if(response.data.data.success == true){
          setIsCompleted(true)
        }
        setIsLoading(false)
      // }

      // if (signCanvasRef.current) {
        
      //   const response = await dispatch(Signature({ mobile: user?.mobile, email: user?.email, user_id: user.user_id, sign_data: signData, source: "retake" })).unwrap();

      //   console.log("hihihih",response)
      //   if(response.data.data.success == true){
      //     setIsCompleted(true)
      //   }
      //   setIsLoading(false)
      // }
    } catch (error) {
      setIsLoading(false)
      console.error('Error while submitting signature:', error);
      setErrMessage(error?.data?.data?.message || "Somthing Went while uploading Signature")
    }
  };

  const clearCanvas = () => {
    signCanvasRef.current.clear();
    setErrMessage("")

  };

  const handleClearFile = () => {
    setUploadedFile(null);
  };

  const handleFileChange = async (file) => {
    signCanvasRef.current.clear()
    setErrMessage("")
    setMode("upload")

    try {
      const base64 = await validateAndConvertImage(file);
      setUploadedBase64(base64);
      console.log(base64 , "base64")
      setUploadedFile(file);
    } catch (error) {
      console.error( error.message);

      setErrMessage(error.message)
    }
  };

  const validateAndConvertImage = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return reject(new Error("No file provided."));
      if (file.type !== "image/jpeg") return reject(new Error("Only JPG images are allowed."));
      if (file.size > 2 * 1024 * 1024) return reject(new Error("Image size must be less than 2MB."));

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("Failed to read file."));
    });
  };


  




  return (

    <>
          <Box sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            minHeight: "100vh !important",
            backgroundImage: `url(${SignUpBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
          }}>



            <Box className={SignatureStyles.content_wrapper}>
              {isCompleted && <Grid2 flexDirection="column" display="flex" justifyContent="center" alignItems="center" height="600px">
                <img src={success} alt="successLogo" />
                <Typography className={SignatureStyles.title}>Your Signature has been completed successfully</Typography>
                {/* <Grid2 className={SignatureStyles.card}>
                  <Button onClick={() => {
                    setIsCompleted(false)
                  }} className={SignatureStyles.skip}>
                    Edit
                  </Button>

                </Grid2> */}
              </Grid2>}
              {!isCompleted && <>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  width: '100%',
                  marginBottom: '10px',
                  marginTop: '0px',
                }}>
                  {/* Back arrow button - only shows below 1000px */}
                  {/* <Box sx={{
                    position: 'absolute',
                    left: 0,

                    '@media (min-width: 1000px)': {
                      display: 'none' // Explicitly hide above 1000px
                    }
                  }}>
                    <IconButton
                      onClick={() => navigate('/step-7')} // Or your custom back handler
                      sx={{
                        color: '#000', // Customize color
                        padding: '16px'
                      }}
                    >
                      <ArrowBack /> 
                    </IconButton>
                  </Box> */}

                  {/* Logo - centered */}
                  <img
                    src={navLogo}
                    alt="Logo"
                    style={{
                      // Adjust margin to account for arrow on mobile
                      marginLeft: { xs: '40px', md: 0 }
                    }}
                    className={SignatureStyles.nav_logo}
                  />
                </Box>
                <Typography className={SignatureStyles.title}>Capture Signature</Typography>



                {!isMobileQRFlow ? (
                  !qrURL ? (
                    <>

                      {
                        isSmallScreen ?
                          <>
                            <Grid2
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center", // Center items horizontally


                              }}
                            >
                              {/* File Uploader Section */}
                              <Grid2
                                onClick={() => {
                                  setErrMessage("");
                                }}
                                className={SignatureStyles.upload_card}
                              // Ensure it spans full width if needed
                              >
                                <Grid2 >
                                  <Typography className={SignatureStyles.upload_txt}>
                                    Upload a close-up clear picture of the signature
                                  </Typography>

                                  <FileUploader
                                    fileOrFiles={uploadedFile}
                                    multiple={false}
                                    maxSize="2mb"
                                    label="Upload or drop a file right here"
                                    handleChange={handleFileChange}
                                    onClick={handleClearFile}
                                    name="file"
                                    disabled={!!uploadedFile}
                                    children={
                                      <Box className={SignatureStyles.upload_box}>
                                        {!uploadedFile ? (
                                          <Typography
                                            sx={{
                                              color: "#999999",
                                              fontFamily: "Inter400",
                                              fontSize: "14px",
                                              textAlign: "center", // Center text
                                            }}
                                          >
                                            Drag and Drop here /{" "}
                                            <span className={SignatureStyles.browse_text}>
                                              Browse File
                                            </span>
                                          </Typography>
                                        ) : (
                                          <Grid2
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                color: "#999999",
                                                fontFamily: "Inter400",
                                                fontSize: "14px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                width: 100,
                                              }}
                                            >
                                              {uploadedFile?.name}
                                            </Typography>
                                            <CloseIcon
                                              sx={{
                                                fontSize: "30px",
                                                cursor: "pointer",
                                                marginLeft: "8px",
                                              }}
                                              onClick={handleClearFile}
                                            />
                                          </Grid2>
                                        )}
                                      </Box>
                                    }
                                  />
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "end",
                                    }}
                                  >
                                    <img
                                      src={lock}
                                      alt="locker"
                                      style={{
                                        width: "10px",
                                        height: "12.5px",
                                      }}
                                    />
                                    <Typography
                                      sx={{
                                        fontFamily: "Inter400",
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        letterSpacing: "0px",
                                        color: "#7A7C7F",
                                        padding: "0px 0px 0px 5px",
                                      }}
                                    >
                                      Secure
                                    </Typography>
                                  </Box>
                                  {/* Error Message */}
                                  {errMessage && mode === "upload" && (
                                    <Typography
                                      className={SignatureStyles.upload_txt}
                                      sx={{ fontSize: "14px", color: "red !important", textAlign: "center" }}
                                    >
                                      {errMessage}
                                    </Typography>
                                  )}
                                </Grid2>
                              </Grid2>



                              <Grid2
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "70%",
                                  gap: "10px",
                                  marginTop: "15px",
                                  "@media (max-width:385px)": {
                                    width: "75%",
                                  },
                                  "@media (max-width:350px)": {
                                    width: "80%",
                                  },
                                  "@media (max-width:340px)": {
                                    width: "85%",
                                  },

                                }}
                              >
                                {/* Left Line */}
                                <Box
                                  sx={{
                                    flex: 1, // Ensures the line spans the available space
                                    borderBottom: "1px solid #999999", // Line styling
                                    height: "1px",
                                  }}
                                />
                                {/* OR Text */}
                                <Typography
                                  className={SignatureStyles.or}

                                >
                                  OR
                                </Typography>
                                {/* Right Line */}
                                <Box
                                  sx={{
                                    flex: 1, // Ensures the line spans the available space
                                    borderBottom: "1px solid #999999", // Line styling
                                    height: "1px",
                                  }}
                                />
                              </Grid2>
                              <Typography className={SignatureStyles.sub_title}>
                                Draw Signature on screen exactly as per your PAN card
                              </Typography>

                              <div className={SignatureStyles.canva_outer}>
                                <Grid2 className={SignatureStyles.canva_inner}>
                                  <SignatureCanvas
                                    onBegin={() => {
                                      setErrMessage("")
                                      setUploadedFile(null)
                                      setMode("draw")
                                    }}
                                    canvasProps={{ className: SignatureStyles.sig_canvas }}
                                    penColor='black'
                                    velocityFilterWeight='0.1'
                                    imageType="image/jpeg"
                                    backgroundColor='white'
                                    ref={(ref) => {
                                      signCanvasRef.current = ref
                                    }}
                                  />
                                  <span onClick={clearCanvas} className={SignatureStyles.retake}>Retake</span>
                                </Grid2>
                              </div>
                              {errMessage && mode == "draw" && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "14px", color: "red !important" }}>
                                {errMessage}
                              </Typography>}

                            </Grid2>

                          </> :
                          <>
                            <Typography className={SignatureStyles.sub_title}>
                              Draw Signature on screen exactly as per your PAN card
                            </Typography>

                            <div className={SignatureStyles.canva_outer}>
                              <Grid2 className={SignatureStyles.canva_inner} sx={{ width: "100%" }}>
                                <SignatureCanvas
                                  onBegin={() => {
                                    setErrMessage("")
                                    setUploadedFile(null)
                                    setMode("draw")
                                  }}
                                  canvasProps={{ className: SignatureStyles.sig_canvas }}
                                  penColor='black'
                                  velocityFilterWeight='0.1'
                                  imageType="image/jpeg"
                                  backgroundColor='white'
                                  ref={(ref) => {
                                    signCanvasRef.current = ref
                                  }}
                                />
                                <span onClick={clearCanvas} className={SignatureStyles.retake}>Retake</span>
                              </Grid2>
                            </div>
                            {errMessage && mode == "draw" && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "14px", color: "red !important" }}>
                              {errMessage}
                            </Typography>}

                            <Typography className={SignatureStyles.or}>OR</Typography>

                            <Grid2 onClick={() => {
                              setErrMessage("")
                            }} className={SignatureStyles.upload_card}>
                              <Grid2>
                                <Typography className={SignatureStyles.upload_txt}>
                                  Upload a close-up clear picture of the signature
                                </Typography>

                                <FileUploader
                                  fileOrFiles={uploadedFile}
                                  multiple={false}
                                  maxSize="2mb"
                                  label="Upload or drop a file right here"
                                  handleChange={handleFileChange}
                                  onClick={handleClearFile}
                                  name="file"
                                  disabled={!!uploadedFile}
                                  children={
                                    <Box className={SignatureStyles.upload_box}>
                                      {!uploadedFile ? (
                                        <Typography sx={{ color: "#999999", fontFamily: "Inter400", fontSize: "14px" }}>
                                          Drag and Drop here / <span className={SignatureStyles.browse_text}>Browse File</span>
                                        </Typography>
                                      ) : (
                                        <Grid2 sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                          <Typography sx={{
                                            color: "#999999", fontFamily: "Inter400", fontSize: "14px",
                                            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: 100
                                          }}>
                                            {uploadedFile?.name}
                                          </Typography>
                                          <CloseIcon sx={{ fontSize: "30px", cursor: "pointer", marginLeft: "8px" }} onClick={handleClearFile} />
                                        </Grid2>
                                      )}
                                    </Box>
                                  }
                                />
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                  }}
                                >
                                  <img
                                    src={lock}
                                    alt="locker"
                                    style={{
                                      width: "10px",
                                      height: "12.5px",
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: "Inter400",
                                      fontSize: "14px",
                                      lineHeight: "20px",
                                      letterSpacing: "0px",
                                      color: "#7A7C7F",
                                      padding: "0px 0px 0px 5px",
                                    }}
                                  >
                                    Secure
                                  </Typography>
                                </Box>
                                {errMessage && mode == "upload" && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "14px", color: "red !important" }}>
                                  {errMessage}
                                </Typography>}
                              </Grid2>

                              {!screen768px && <Grid2>
                                <Typography className={SignatureStyles.upload_txt} sx={{ textAlign: "right", fontSize: "14px" }}>
                                  Click here to do Signature on mobile
                                </Typography>
                                <Grid2 className={SignatureStyles.qrCodeGrid} sx={{ height: "63px !important", width: "700px" }}>
                                  {!isQRMode && <Button onClick={handleGenerateQR} ><Typography sx={{ color: "#42a0f7", textDecoration: "underlined", fontFamily: "Inter400" }}>Generate QR</Typography></Button>}
                                </Grid2>
                              </Grid2>}
                            </Grid2>
                          </>
                      }

                    </>
                  ) : (
                    <Grid2>
                      <Typography className={SignatureStyles.sub_title}>Scan This QR on your Phone</Typography>
                      <Grid2 className={SignatureStyles.qrCodeGrid}>
                        <QRCodeCanvas value={qrURL} size={159} />
                      </Grid2>
                    </Grid2>
                  )
                ) : (
                  <>
                    <Typography className={SignatureStyles.sub_title}>Draw Signature on screen exactly as per your PAN card</Typography>
                    <div className={SignatureStyles.canva_outer}>
                      <Grid2 className={SignatureStyles.canva_inner} sx={{ padding: "0px 20px", width: "100%" }}>
                        <SignatureCanvas
                          ref={signCanvasRef}
                          penColor="black"
                          canvasProps={{ className: SignatureStyles.sig_canvas }}
                        />
                        <span onClick={clearCanvas} className={SignatureStyles.retake}>Retake</span>
                      </Grid2>
                    </div>
                  </>
                )}

                <Grid2 className={SignatureStyles.but_card} container
                  spacing={2}
                  direction={{ xs: "column-reverse !important", md: "row !important" }}>
                  <Grid2>
                    <Button disabled={isLoading} onClick={handleSignatureSubmit} className={SignatureStyles.con_button}>
                      {isLoading ? <CircularProgress size="30px" /> :
                        <p>{qrURL ? "Cancel" : "Submit"}</p>}
                    </Button>
                  </Grid2>
                </Grid2>
                {qrURL && <Grid2>
                  <Typography className={SignatureStyles.txt} mt="20px">
                    After you complete signature on mobile please <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => setCheckStatus(!checkStatus)}>click here</span> to continue
                  </Typography>
                  {errMessage && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "14px", color: "red !important", textAlign: "center" }}>
                    {errMessage}
                  </Typography>}
                </Grid2>}

                {!isMobileQRFlow && (
                  <Box className={SignatureStyles.txt_card}>
                    <img src={icon} alt="Checkmark" className={SignatureStyles.icon} />
                    <Typography className={SignatureStyles.txt}>
                      Your account details are safe & secure with us.
                    </Typography>
                  </Box>
                )}
              </>}
            </Box>
          </Box>
      
    </>
    
  );
}
 

